import React from "react";
import "./CustomVideoCard.css";
export default function CustomVideoCard({card, content, messageId, conversationId, iid, replyToId,cardActivitiesSummary,inZenDesk }) {
    let feedback_response = JSON.parse(localStorage.getItem(iid + "-chatfeedback"));
    let feedbackbody;
    if (feedback_response !== null) {
        feedbackbody = feedback_response.filter(i => i.messageId === messageId)[0];
    }
    return (
        <div className="videocard-container" data-activity-id={messageId} data-con-id={conversationId}
            data-feedback={feedbackbody !== undefined && feedbackbody.feedback}
            data-view-btn={replyToId} data-msg-type={cardActivitiesSummary}
            data-inzendesk={inZenDesk}>
            <ul className="media-list">
                <li>
                    <iframe className="videocard-iframe" allowFullScreen="allowfullscreen"
                        src={content.media[0].url.toString()
                            .replace("https://www.youtube.com/watch?v=", "https://www.youtube.com/embed/")
                            .replace("https://vimeo.com/", "https://player.vimeo.com/video/")}></iframe>
                </li>
            </ul>
            {content.title !== undefined &&
                <div className="videocard-text-area">
                    <div className="ac-textBlock videocard-title-text">
                        {content.title}
                    </div>
                </div>
            }       
        </div>
    );
}